import { useTranslation } from 'react-i18next';
import { MainLayout } from '../../Layout/MainLayout';
import { MainBreadcrumbs } from '../../Layout/MainBreadcrumbs';
import { useCustomerQuery } from '../../../api/customers';
import { useBoolean } from 'usehooks-ts';
import { UpdatedView } from './UpdatedView';
import { UpdateNameForm } from './UpdateNameForm';

export function UpdateNamePage() {
  const { t } = useTranslation();
  const customerQuery = useCustomerQuery();
  const customer = customerQuery.data;
  const changedFlag = useBoolean(false);

  return (
    <MainLayout
      title={
        <MainBreadcrumbs
          title={t('Change name')}
          parent={{
            to: '/account/settings',
            title: t('Settings'),
          }}
        />
      }
      compact
    >
      {customer?.individual ? (
        changedFlag.value ? (
          <UpdatedView text={t('Name successfully changed')} />
        ) : (
          <UpdateNameForm customer={customer.individual} onComplete={changedFlag.setTrue} />
        )
      ) : null}
    </MainLayout>
  );
}
